import { render, staticRenderFns } from "./ViewDocumentsModal.vue?vue&type=template&id=60d4f28e&scoped=true&"
import script from "./ViewDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocumentsModal.vue?vue&type=style&index=0&id=60d4f28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4f28e",
  null
  
)

export default component.exports